import { configureLocalization } from '@lit/localize';
import { sourceLocale, targetLocales } from '../../../locale/generated/locale-codes';

/**
 * Configure lit-localize for runtime locale switching
 */
export const { getLocale, setLocale } = configureLocalization({
    sourceLocale,
    targetLocales,
    loadLocale: (locale: string) => import(`../../../locale/generated/locales/${locale}.ts`),
});

/**
 * Set the locale based on the component's lang attribute
 * @param lang - Language code (e.g., 'de', 'en', 'fr', 'it', 'en-EN', 'fr-CH', 'it-IT')
 * @returns Promise that resolves when locale is loaded
 */
export async function updateLocale(lang: string): Promise<void> {
    // Map common language codes to the locale codes used in the project
    // Supports both short codes (de, en, fr, it) and full locale codes (en-EN, fr-CH, it-IT)
    const localeMap: Record<string, string> = {
        de: 'de-CH',
        'de-CH': 'de-CH',
        en: 'en-EN',
        'en-EN': 'en-EN',
        fr: 'fr-CH',
        'fr-CH': 'fr-CH',
        it: 'it-IT',
        'it-IT': 'it-IT',
    };

    const locale = localeMap[lang] || 'de';

    if (getLocale() !== locale) {
        await setLocale(locale);
    }
}
